<template>
  <svg
    version="1.1"
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    viewBox="0 0 641.77 507.38"
    xml:space="preserve"
  >
    <g>
      <path
        d="M145.94,46.11c-12.88,0-18.18,4.36-19.56,17.28c-3.42,32.22-6.07,64.4-9.2,97.52h495.36
		c-0.96-18.14-1.44-35.9-3.18-53.49c-1.1-11.17-6.13-14.89-18.11-15.27c-11.98-0.39-24.05-0.17-36.03-0.17
		c-62.25,0-124.46-0.17-186.67,0c-13.13,0.55-25.87-4.58-34.96-14.08c-6.62-6.94-13.27-13.91-19.43-21.27
		c-5.5-6.86-13.88-10.75-22.67-10.52C242.97,46.11,194.45,45.86,145.94,46.11z"
      />
      <path
        d="M100.53,60.65c2.79-26.12,18.89-40.5,45.34-40.53C160.4,20.04,176.3,20,194.45,20c13.33,0,26.66,0.02,40,0.05
		c-2.82-3.08-5.61-6.21-8.29-9.41c-5.5-6.86-13.88-10.75-22.67-10.52c-48.52,0-97.04-0.26-145.55,0c-12.88,0-18.18,4.36-19.56,17.28
		c-3.42,32.22-6.07,64.4-9.2,97.52h66.1C96.91,96.99,98.61,78.69,100.53,60.65z"
      />
      <path
        d="M75.1,395.8c-1.74-24.01-3.46-48.4-5.12-71.97c-2.44-34.58-4.96-70.34-7.59-105.5
		c-1.1-15.18-0.59-32.38,11.48-45.34c5.08-5.46,11.04-8.93,17.35-11.11c-0.04-1.13-0.02-2.26,0.09-3.4
		c0.64-6.73,1.26-13.48,1.87-20.17c-21.14,0-42.28,0-63.41,0c-25.45,0-31.28,6.62-29.44,32.09c4.42,59.18,8.43,118.33,12.71,177.51
		c2.19,29.96,4.23,59.89,6.97,89.81c-0.21,12.69,9.92,23.15,22.61,23.35c0.58,0.01,1.16,0,1.74-0.04c2.87,0.26,5.78,0.35,8.65,0.35
		h27c-1.36-16.81-2.58-33.59-3.76-49.99C75.85,406.19,75.48,400.99,75.1,395.8z"
      />
      <path
        d="M621.52,184.43c-2.13-0.13-4.32-0.13-6.46-0.13H366.45c-82.91,0-165.81,0-248.7,0
		c-25.45,0-31.28,6.62-29.44,32.09c4.42,59.18,8.43,118.33,12.71,177.51c2.19,29.96,4.23,59.89,6.97,89.81
		c-0.21,12.69,9.92,23.15,22.61,23.35c0.58,0.01,1.16,0,1.74-0.04c2.87,0.26,5.78,0.35,8.65,0.35h447.65
		c27.6,0,34.35-7.07,35.9-34.87c1.84-33.38,4.23-66.66,6.42-99.99c3.68-55.37,7.36-110.73,10.75-166.08
		C642.46,191.53,636.46,185.29,621.52,184.43z M432.44,343.87c-0.46,0.55-0.96,1.06-1.49,1.54h-0.02
		c-21.57,21.99-43.34,43.79-65.34,65.38c-6.14,6.18-16.12,6.21-22.3,0.07c-0.02-0.02-0.05-0.05-0.07-0.07
		c-6.44-5.71-7.04-15.56-1.34-22c0.31-0.35,0.64-0.69,0.99-1.02c10.01-10.62,20.57-20.7,30.84-31.1c1.79-2.03,3.47-4.16,5.04-6.37
		h-84.37c-12.71,0-25.41,0.26-38.13-0.17c-8.66-0.03-15.65-7.07-15.62-15.73c0-0.06,0-0.12,0-0.19
		c-0.15-8.67,6.58-15.91,15.24-16.39c3.18-0.21,6.37-0.26,9.55-0.13h113.9c-3.68-3.94-5.74-6.29-7.91-8.46
		c-9.42-9.46-19.08-18.66-28.24-28.37c-6.42-5.78-6.95-15.67-1.17-22.09c0.29-0.32,0.59-0.63,0.91-0.93
		c5.68-6.36,15.43-6.92,21.8-1.25c0.4,0.35,0.77,0.73,1.13,1.12c21.82,21.34,43.41,42.89,64.77,64.64
		C437.05,327.79,437.88,337.42,432.44,343.87z"
      />
    </g>
  </svg>
</template>

<script>
  export default {};
</script>

<style></style>
